import { h, render, Component } from 'preact';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import FourOhFour from './FourOhFour';
import Authenticated from './Authenticated';
import Dashboard from './Dashboard';
import store from '../store/store';
import SignIn from './SignIn';
import AddNewUser from './AddNewUser';
import Users from './Users';
import AddInvoice from './AddInvoice';
import AddCustomer from './AddCustomer';
import EditInvoice from './EditInvoice';
import Customers from './Customers';
import CustomerDetail from './CustomerDetail';
import InvoiceDetail from './InvoiceDetail';
import MyAccount from './MyAccount';
const App = () => h(Provider, { store: store },
    h(Switch, null,
        h(Route, { exact: true, path: "/", component: () => h(Authenticated, null,
                h(Dashboard, null)) }),
        h(Route, { exact: true, path: "/login", component: SignIn }),
        h(Route, { exact: true, path: "/customers", component: () => h(Authenticated, null,
                h(Customers, { isEditable: true })) }),
        h(Route, { exact: true, path: "/add/customer", component: () => h(Authenticated, null,
                h(AddCustomer, null)) }),
        h(Route, { path: "/customer/:id", component: props => h(Authenticated, null,
                h(CustomerDetail, { id: props.match.params.id })) }),
        h(Route, { exact: true, path: "/add/invoice", component: () => h(Authenticated, null,
                h(AddInvoice, { type: "invoice" })) }),
        h(Route, { exact: true, path: "/add/proposal", component: () => h(Authenticated, null,
                h(AddInvoice, { type: "proposal" })) }),
        h(Route, { exact: true, path: "/edit/invoice/:id", component: (props) => h(Authenticated, null,
                h(EditInvoice, { id: props.match.params.id })) }),
        h(Route, { path: "/invoice/:id", component: props => h(Authenticated, null,
                h(InvoiceDetail, { id: props.match.params.id })) }),
        h(Route, { exact: true, path: "/add/user", component: () => h(Authenticated, null,
                h(AddNewUser, null)) }),
        h(Route, { exact: true, path: "/users", component: () => h(Authenticated, null,
                h(Users, null)) }),
        h(Route, { exact: true, path: "/myaccount", component: () => h(Authenticated, null,
                h(MyAccount, null)) }),
        h(Route, { component: FourOhFour })));
export default App;
